'use strict';
import { Injectable} from 'ng-metadata/core';
import {isBrowserSafari} from '../infra/browserSniffer';

const Observable= require('rxjs/Observable').Observable;
require('rxjs/add/observable/defer');
require('rxjs/add/observable/interval');
require('rxjs/add/operator/map');
require('rxjs/add/operator/takeWhile');

const animationFrame= require('rxjs/scheduler/animationFrame').animationFrame;


interface Node {
    scrollTop: number;
}

interface Window {
    chrome: any;
    StyleMedia: any;
    HtmlElement:any;
}


@Injectable()
export class SmoothScrollUtil {
    private window: Node;
    private existingAnimationSubscription;

    constructor(){
        let scheduler= animationFrame;
        this.msElapsed= Observable.defer(()=>{
            let start = scheduler.now();
            return Observable.interval(0, scheduler).map(()=> scheduler.now() - start);
        });
    }
    /*this function will smooth scroll to element with id=eid. 
       If scrollContainerId is undef will locate the scroll container by tag name (the first element of that tag).
       If both scrollContainerId and scrollContainerTagName are undef will use root element as scrollContainer.
       offset is the distance you would like to leave between the element you scroll to and top of the screen
 
    */

    public focusOn(elm){
        this.elementFocus(elm);
        return elm;
    }

    public elementFocus(elm){
        if(elm) {
            if(typeof elm === 'string') {
                elm = document.getElementById(elm);
            }
            if(!elm) {
                return;
            }
            let hasTabIndex = elm.getAttribute('tabindex') === '0';
            elm.setAttribute('tabindex','-1');
            elm.focus();
            if(hasTabIndex) {
                elm.setAttribute('tabindex', '0');
            }
        }
    }

    public scrollTo(eID, scrollContainerId, scrollContainerTagName, offset: number= 70){
        let scrollContainer= <Node> this.getScrollContainer(scrollContainerId,scrollContainerTagName);
        let elm = document.getElementById(eID);
        if (!elm){
            return;
        }

        let startY = this.currentYPosition(scrollContainer);

        let stopY;
        if(elm) {
            stopY = this.elmYPosition(elm) - this.elmYPosition(scrollContainer) - offset;
        }
        stopY= stopY<0? 0: stopY;
        let maxY= scrollContainer.scrollHeight - scrollContainer.offsetHeight;
        stopY= Math.min(maxY, stopY);
        let distance = stopY > startY ? stopY - startY : startY - stopY;
        if (distance < 100) {
            scrollContainer.scrollTop= stopY;
            this.focusOn(elm);
            return;
        }
        let unitsPerSecond = Math.round(distance / 100)+30;
        if (unitsPerSecond >= 150) {
            unitsPerSecond = 150;
        }
        if (this.existingAnimationSubscription){
            this.existingAnimationSubscription.unsubscribe(); //stop any existing animations
        }
        this.existingAnimationSubscription= this.msElapsed.map(ms =>
            Math.ceil(unitsPerSecond * ms / 1000)).takeWhile(() => Math.abs(scrollContainer.scrollTop - stopY) > 1).subscribe((distance) => {
                let current= scrollContainer.scrollTop;
                if (stopY > startY) {
                    scrollContainer.scrollTop = Math.min(stopY, current + distance);
                }
                if (stopY < startY){
                    scrollContainer.scrollTop = Math.max(stopY, current - distance);
                }
        }, ()=>{
            console.log("something went wrong during smooth scroll");
            this.focusOn(elm);
        }, ()=>{
            this.focusOn(elm);
        });

    }
    
        private currentYPosition(scrollContainer) {
            return scrollContainer.scrollTop;
        }
    
        private elmYPosition(elm) {
            let y = elm.offsetTop;
            let node = elm;
            while (node.offsetParent && node.offsetParent != document.body) {
                node = node.offsetParent;
                y += node.offsetTop;
            } return y;
        }
    
        private getScrollContainer(scrollContainerId,scrollContainerTagName){
            let scrollContainer;
            if(scrollContainerId){
                return document.getElementById(scrollContainerId);
            }
            if(scrollContainerTagName){
                return document.querySelector(scrollContainerTagName);
            }
            let isIE= false || !!document.documentMode;
            //if chrome or safari or edge get document body
            let w: Window = <Window> window;
            if (isBrowserSafari() ||
                (Object.prototype.toString.call(w.HTMLElement).indexOf('Constructor') > 0) ||
                (!isIE && !!w.StyleMedia)){
                return document.body;
            }
            return document.body.parentNode;
        }
    
    
    
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/nddUtils/smoothScrollUtil.service.ts